import { normalizeDateOfBirth } from '@/lib/helpers/dateHelpers'
import { ClientDetailsFormValues } from '@/pages/referralLink/constants'

export function normalizeClientDetailsValues(
  values: ClientDetailsFormValues,
): ClientDetailsFormValues {
  return {
    ...values,
    dateOfBirth: hasProvidedDateOfBirth(values.dateOfBirth)
      ? normalizeDateOfBirth(values.dateOfBirth)
      : undefined,
  }
}

export function hasProvidedDateOfBirth(
  dateOfBirth?: string,
): dateOfBirth is string {
  return !!dateOfBirth && !!dateOfBirth.replaceAll('/', '').trim()
}
